import React from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import {
    GridContainer,
    GridItem1,
    GridItem3xs6,
    GridItem4,
    GridItem6,
    GridItem7sm12xs12,
    GridItem9,
    GridItem10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

 import {
    CardGridEntradaDados,
    CardGridEntradaDadosHeaderBody,
    CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import { 
    TextValidatorValor,
    TextValidatorNumber,
    TextValidatorNumberRequired,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldTextSelect,
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import { 
    MorteInvalidezEstudoRadioGroup,
} from '../../../business-rules/RadioGroup/MorteInvalidezEstudoRadioGroup'

import mesesEmergencialList from '../../../business-rules/List/mesesEmergencialList'

import mesesSugestaoDoencasGravesList from '../../../business-rules/List/mesesSugestaoDoencasGravesList'

import tipoCalculoSugestaoDoencasGravesList from '../../../business-rules/List/tipoCalculoSugestaoDoencasGravesList'

import {
    dadosCompletosConjuge,
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    processaValoresDefaultIniciaisSucessaoVitalicia,
    processaAlteracaoSucessaoVitaliciaMesesEmergencialCliente,
    processaAlteracaoSucessaoVitaliciaMesesEmergencialConjuge,
} from '../estudo-form/EstudoServiceSucessaoVitalicia'

import {
    IdadeSimulacaoMorteCliente,
} from './EstudoCompClienteConjuge'

import {
    processaValoresDefaultIniciaisConfiguracaoProtecao,
} from './EstudoServiceConfiguracaoProtecao'

import {
    ExibirCapitalSeguradoCarteiraInvestimentos,
    IncluirSugestaoPrevidenciaPrivadaSeguroVidaInteiraSucessaoVitalicia,
    UtilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia,
} from './EstudoCompConfiguracao'



const EstudoFormConfiguracaoProtecao = ( { values, handleChange, handleSubmit, vars } ) => {

    processaValoresDefaultIniciaisSucessaoVitalicia(values)

    processaValoresDefaultIniciaisConfiguracaoProtecao(values)
    


    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer
                className="justify-center"
            >
                <GridItem7sm12xs12>
                    <CardGridEntradaDados>
                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.sucessaoVitalicia}
                        >
                            <GridContainer>
                                <GridItem3xs6>
                                    <TextValidatorNumberRequired
                                        name="percDespesasAdvocaticias"
                                        label={LABEL.percDespesasAdvocaticias}
                                        value={values.percDespesasAdvocaticias === 0 ? 0 : values.percDespesasAdvocaticias || ''}
                                        onChange={handleChange}
                                        numMin={NUMMIN.perc}
                                        numMax={NUMMAX.perc}
                                    />
                                </GridItem3xs6>

                                <GridItem3xs6>
                                    <TextValidatorNumberRequired
                                        name="percCustasJudiciais"
                                        label={LABEL.percCustasJudiciais}
                                        value={values.percCustasJudiciais === 0 ? 0 : values.percCustasJudiciais || ''}
                                        onChange={handleChange}
                                        numMin={NUMMIN.perc}
                                        numMax={NUMMAX.perc}
                                    />
                                </GridItem3xs6>
                                
                                <GridItem3xs6>
                                    <TextValidatorNumber
                                        name="percInventarioItcmd"
                                        label={LABEL.percItcmd}
                                        value={values.percInventarioItcmd === 0 ? 0 : values.percInventarioItcmd || ''}
                                        onChange={handleChange}
                                        numMin={NUMMIN.perc}
                                        numMax={NUMMAX.perc}
                                    />
                                </GridItem3xs6>
                            </GridContainer>
                            
                            <GridContainer>
                                <GridItem12>
                                    <GridContainer
                                        className='justify-center mt-2'
                                    >
                                        <GridItem10>
                                            <CardGridEntradaDadosHeaderBody
                                                title={tituloCliente(values)}
                                            >
                                                <GridContainer>
                                                    <GridItem4
                                                        style={{
                                                            display: 
                                                                !values.alterarValoresAutomaticosSucessaoVitaliciaCliente
                                                                    ? "block"
                                                                    : "none"
                                                        }} 
                                                    >
                                                        <TextFieldNumberSelect
                                                            name="mesesEmergencialCliente"
                                                            label={LABEL.mesesEmergencial}
                                                            value={values.mesesEmergencialCliente || ''}
                                                            onChange={handleChange}
                                                            list={mesesEmergencialList}
                                                            onBlur={processaAlteracaoSucessaoVitaliciaMesesEmergencialCliente(values)}
                                                        />
                                                    </GridItem4>

                                                    <GridItem4>
                                                        <TextValidatorValor
                                                            name="emergencialCliente"
                                                            label={LABEL.emergencial}
                                                            value={values.emergencialCliente === 0 ? 0 : values.emergencialCliente || ''}
                                                            onChange={handleChange}
                                                            disabled={!values.alterarValoresAutomaticosSucessaoVitaliciaCliente}
                                                        />
                                                    </GridItem4>

                                                    <GridItem4>
                                                        <TextValidatorValor
                                                            name="inventarioCliente"
                                                            label={LABEL.inventario}
                                                            value={values.inventarioCliente === 0 ? 0 : values.inventarioCliente || ''}
                                                            onChange={handleChange}
                                                            disabled={!values.alterarValoresAutomaticosSucessaoVitaliciaCliente}
                                                        />
                                                    </GridItem4>
                                                </GridContainer>

                                                <GridContainer>
                                                    <GridItem6>
                                                        <CheckboxPadrao
                                                            name="alterarValoresAutomaticosSucessaoVitaliciaCliente"
                                                            label={LABEL.alterarValoresAutomaticos}
                                                            checked={values.alterarValoresAutomaticosSucessaoVitaliciaCliente}
                                                            onChange={handleChange}
                                                        />
                                                    </GridItem6>
                                                </GridContainer>
                                            </CardGridEntradaDadosHeaderBody>
                                        </GridItem10>

                                        <GridItem10
                                            style={{
                                                display:
                                                    dadosCompletosConjuge(values)
                                                        ? "block"
                                                        : "none"
                                            }}
                                        >
                                            <CardGridEntradaDadosHeaderBody
                                                title={tituloConjuge(values)}
                                            >
                                                <GridContainer>
                                                    <GridItem4
                                                        style={{
                                                            display: 
                                                                !values.alterarValoresAutomaticosSucessaoVitaliciaConjuge
                                                                    ? "block"
                                                                    : "none"
                                                        }} 
                                                    >
                                                        <TextFieldNumberSelect
                                                            name="mesesEmergencialConjuge"
                                                            label={LABEL.mesesEmergencial}
                                                            value={values.mesesEmergencialConjuge || ''}
                                                            onChange={handleChange}
                                                            list={mesesEmergencialList}
                                                            onBlur={processaAlteracaoSucessaoVitaliciaMesesEmergencialConjuge(values)}
                                                        />
                                                    </GridItem4>

                                                    <GridItem4>
                                                        <TextValidatorValor
                                                            name="emergencialConjuge"
                                                            label={LABEL.emergencial}
                                                            value={values.emergencialConjuge === 0 ? 0 : values.emergencialConjuge || ''}
                                                            onChange={handleChange}
                                                            disabled={!values.alterarValoresAutomaticosSucessaoVitaliciaConjuge}
                                                        />
                                                    </GridItem4>

                                                    <GridItem4>
                                                        <TextValidatorValor
                                                            name="inventarioConjuge"
                                                            label={LABEL.inventario}
                                                            value={values.inventarioConjuge === 0 ? 0 : values.inventarioConjuge || ''}
                                                            onChange={handleChange}
                                                            disabled={!values.alterarValoresAutomaticosSucessaoVitaliciaConjuge}
                                                        />
                                                    </GridItem4>
                                                </GridContainer>
                                                
                                                <GridContainer>
                                                    <GridItem6>
                                                        <CheckboxPadrao
                                                            name="alterarValoresAutomaticosSucessaoVitaliciaConjuge"
                                                            label={LABEL.alterarValoresAutomaticos}
                                                            checked={values.alterarValoresAutomaticosSucessaoVitaliciaConjuge}
                                                            onChange={handleChange}
                                                        />
                                                    </GridItem6>
                                                </GridContainer>
                                            </CardGridEntradaDadosHeaderBody>
                                        </GridItem10>
                                    </GridContainer>
                                </GridItem12>
                            </GridContainer>

                            <GridContainer>
                                {!values.utilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia && (
                                    <GridItem9>
                                        <IncluirSugestaoPrevidenciaPrivadaSeguroVidaInteiraSucessaoVitalicia
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem9>
                                )}
                                
                                {!values.incluirSugestaoPrevidenciaPrivadaSeguroVidaInteiraSucessaoVitalicia && (
                                    <GridItem9>
                                        <UtilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem9>
                                )}
                            </GridContainer>
                        </CardGridEntradaDadosHeaderBody>

                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.protecaoSugerida}
                        >
                            <GridContainer>
                                <GridItem12>
                                    <CheckboxPadrao
                                        name="naoAplicarTaxaJurosSeguroVida"
                                        label={LABEL.naoAplicarTaxaJurosSeguroVida}
                                        checked={values.naoAplicarTaxaJurosSeguroVida}
                                        onChange={handleChange}
                                    />
                                </GridItem12>
                            </GridContainer>

                            {!values.naoExibirAcumulacaoAposentadoriaProjetoVidaSonho &&
                            vars.linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' && (
                                <GridContainer>
                                    <GridItem6>
                                        <CheckboxPadrao
                                            name="naoExibirProtecaoRiscos"
                                            label={LABEL.naoExibirProtecaoRiscos}
                                            checked={values.naoExibirProtecaoRiscos}
                                            onChange={handleChange}
                                        />
                                    </GridItem6>
                                </GridContainer>
                            )}

                            {!values.naoExibirProtecaoRiscos
                                ?
                                    <>
                                        <GridContainer>
                                            <GridItem6>
                                                <GridContainer>
                                                    <GridItem6>
                                                        <CheckboxPadrao
                                                            name="exibirMorteAte"
                                                            label={LABEL.exibirMorteAte}
                                                            checked={values.exibirMorteAte}
                                                            onChange={handleChange}
                                                            disabled={values.naoExibirMorteVitalicia}
                                                        />
                                                    </GridItem6>

                                                    <GridItem4
                                                        style={{
                                                            display: 
                                                                values.exibirMorteAte
                                                                    ? "block"
                                                                    : "none"
                                                        }}
                                                    >
                                                        <IdadeSimulacaoMorteCliente
                                                            values={values}
                                                            handleChange={handleChange}
                                                        />
                                                    </GridItem4>
                                                </GridContainer>
                                            </GridItem6>

                                            <GridItem6
                                                style={{
                                                    display: 
                                                        values.exibirMorteAte
                                                            ? "block"
                                                            : "none"
                                                }} 
                                            >
                                                <CheckboxPadrao
                                                    name="naoExibirMorteVitalicia"
                                                    label={LABEL.naoExibirMorteVitalicia}
                                                    checked={values.naoExibirMorteVitalicia}
                                                    onChange={handleChange}
                                                />
                                            </GridItem6>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem6>
                                                <CheckboxPadrao
                                                    name="naoExibirMorteSucessaoVitalicia"
                                                    label={LABEL.naoExibirMorteSucessaoVitalicia}
                                                    checked={values.naoExibirMorteSucessaoVitalicia}
                                                    onChange={handleChange}
                                                />
                                            </GridItem6>

                                            <GridItem6>
                                                <CheckboxPadrao
                                                    name="naoExibirDITDITA"
                                                    label={
                                                        vars.jsonConfiguracao && vars.jsonConfiguracao.textoCoberturaSugeridaDITDITA
                                                            ?
                                                                LABEL.naoExibirCobertura + ' ' +
                                                                    vars.jsonConfiguracao.textoCoberturaSugeridaDITDITA
                                                            :
                                                                LABEL.naoExibirDITDITA
                                                    }
                                                    checked={values.naoExibirDITDITA}
                                                    onChange={handleChange}
                                                />
                                            </GridItem6>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem6>
                                                <CheckboxPadrao
                                                    name="naoExibirDoencasGraves"
                                                    label={LABEL.naoExibirDoencasGraves}
                                                    checked={values.naoExibirDoencasGraves}
                                                    onChange={handleChange}
                                                />
                                            </GridItem6>
                                        </GridContainer>
                                        
                                        {!values.naoExibirDoencasGraves && (
                                            <>
                                                <GridContainer>
                                                    <GridItem6>
                                                        <TextFieldNumberSelect
                                                            name={"mesesSugestaoDoencasGraves"}
                                                            label={LABEL.mesesSugestaoDoencasGraves}
                                                            value={values.mesesSugestaoDoencasGraves === 0 ? 0 : values.mesesSugestaoDoencasGraves || ''}
                                                            onChange={handleChange}
                                                            list={mesesSugestaoDoencasGravesList}
                                                        />
                                                    </GridItem6>

                                                    <GridItem6>
                                                        <TextFieldTextSelect
                                                            name={"tipoCalculoSugestaoDoencasGraves"}
                                                            label={LABEL.tipoCalculoSugestaoDoencasGraves}
                                                            value={values.tipoCalculoSugestaoDoencasGraves || ''}
                                                            onChange={handleChange}
                                                            list={tipoCalculoSugestaoDoencasGravesList}
                                                        />
                                                    </GridItem6>
                                                </GridContainer>
                                                
                                                <GridContainer>
                                                    <GridItem6>
                                                        <TextValidatorValor
                                                            name={"despesasAdicionaisDoencasGravesCliente"}
                                                            label={LABEL.despesasAdicionaisDoencasGraves + ' ' + tituloCliente(values)}
                                                            value={values.despesasAdicionaisDoencasGravesCliente === 0 ? 0 : values.despesasAdicionaisDoencasGravesCliente || ''}
                                                            onChange={handleChange}
                                                        />
                                                    </GridItem6>

                                                    <GridItem6>
                                                        <TextValidatorValor
                                                            name={"despesasAdicionaisDoencasGravesConjuge"}
                                                            label={LABEL.despesasAdicionaisDoencasGraves + ' ' + tituloConjuge(values)}
                                                            value={values.despesasAdicionaisDoencasGravesConjuge === 0 ? 0 : values.despesasAdicionaisDoencasGravesConjuge || ''}
                                                            onChange={handleChange}
                                                        />
                                                    </GridItem6>
                                                </GridContainer>
                                            </>
                                        )}

                                        <GridContainer>
                                            <GridItem6>
                                                <CheckboxPadrao
                                                    name="naoExibirInvalidez"
                                                    label={
                                                        vars.jsonConfiguracao && vars.jsonConfiguracao.textoCoberturaSugeridaInvalidez
                                                            ?
                                                                LABEL.naoExibirCobertura + ' ' +
                                                                    vars.jsonConfiguracao.textoCoberturaSugeridaInvalidez
                                                            :
                                                                LABEL.naoExibirInvalidez
                                                    }
                                                    checked={values.naoExibirInvalidez}
                                                    onChange={handleChange}
                                                />
                                            </GridItem6>
                                        </GridContainer>

                                        <GridContainer>
                                            <GridItem6>
                                                <CheckboxPadrao
                                                    name="naoExibirFuneral"
                                                    label={LABEL.naoExibirFuneral}
                                                    checked={values.naoExibirFuneral}
                                                    onChange={handleChange}
                                                />
                                            </GridItem6>

                                            {!values.naoExibirFuneral && (
                                                <GridItem4>
                                                    <TextValidatorValor
                                                        name="funeral"
                                                        label={LABEL.funeral}
                                                        value={values.funeral === 0 ? 0 : values.funeral || ''}
                                                        onChange={handleChange}
                                                    />
                                                </GridItem4>
                                            )}
                                        </GridContainer>
                                    </>
                                :
                                    <CardGridDividerElementos/>
                            }
                        </CardGridEntradaDadosHeaderBody>

                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.despesasAcumuladasLongoTempo}
                        >
                            <GridContainer>
                                <GridItem12>
                                    <CheckboxPadrao
                                        name="naoExibirDespesasAcumuladasSemDiaDia"
                                        label={LABEL.naoExibirDespesasAcumuladasSemDiaDia}
                                        checked={values.naoExibirDespesasAcumuladasSemDiaDia}
                                        onChange={handleChange}
                                    />
                                </GridItem12>
                            </GridContainer>
                        </CardGridEntradaDadosHeaderBody>

                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.projecaoSucessaoVitalicia}
                        >
                            <GridContainer>
                                <GridItem6>
                                    <CheckboxPadrao
                                        name="exibirProjecaoSucessaoVitaliciaAteIdade"
                                        label={LABEL.exibirProjecaoSucessaoVitaliciaAteIdade}
                                        checked={values.exibirProjecaoSucessaoVitaliciaAteIdade}
                                        onChange={handleChange}
                                    />
                                </GridItem6>
                                {values.exibirProjecaoSucessaoVitaliciaAteIdade && (
                                    <>
                                        <GridItem1>
                                            <TextValidatorNumber
                                                name="idadeExibirProjecaoSucessaoVitaliciaAte"
                                                label={LABEL.idade}
                                                value={
                                                    values.idadeExibirProjecaoSucessaoVitaliciaAte === 0
                                                        ?
                                                            0
                                                        :
                                                            values.idadeExibirProjecaoSucessaoVitaliciaAte || ''
                                                }
                                                onChange={handleChange}
                                                numMin={NUMMIN.idade}
                                                numMax={NUMMAX.idade}
                                            />
                                        </GridItem1>
                                    </>
                                )}
                            </GridContainer>
                        </CardGridEntradaDadosHeaderBody>

                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.gestaoPatrimonial}
                        >
                            <GridContainer>
                                <GridItem12>
                                    <ExibirCapitalSeguradoCarteiraInvestimentos
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem12>
                            </GridContainer>
                        </CardGridEntradaDadosHeaderBody>

                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.buttonDetalhesCalculo}
                        >
                            <GridContainer>
                                <GridItem12>
                                    <MorteInvalidezEstudoRadioGroup
                                        name="morteInvalidezEstudo"
                                        value={values.morteInvalidezEstudo || ''}
                                        onChange={handleChange}
                                        values={values}
                                    />
                                </GridItem12>
                            </GridContainer>
                        </CardGridEntradaDadosHeaderBody>
                    </CardGridEntradaDados>
                </GridItem7sm12xs12>
            </GridContainer>
        </ValidatorForm>
    )
}
                                    
export default EstudoFormConfiguracaoProtecao